import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { IoMdArrowDropright } from "react-icons/io";

export default function OneService({ image, title, description, navToLink = {} }) {

	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);

	useEffect(() => {
		setReady(true);
	}, []);

	return (
		<div 
			data-aos="fade-down"
			className="col-md-6 p-2 d-flex"
			style={{ cursor: "pointer" }}
			onClick={() => appContext.navTo(navToLink)}
		>
			<div
				className="rounded d-flex flex-column w-100"
				style={{
					position: "relative",
					overflow: "hidden",
					minHeight: "45vh",
					backgroundColor: "#000", // fallback if image fails
				}}
			>
				{/* Image */}
				<img 
					src={image} 
					className="w-100 rounded-top"
					style={{
						objectFit: "cover",
						flexShrink: 0,
						height: "200px"
					}}
				/>

				{/* Overlay content */}
				<div
					className="text-light bg-secondary d-flex flex-column justify-content-between p-3 flex-grow-1"
				>
					<div>
						<h5 className="mt-2 font-bold text-primary">{title}</h5>
						<h6 className="mt-2" style={{ fontWeight: 400 }}>
							{description}
						</h6>
					</div>

					<div className="mt-3 align-self-start">
						Learn more <IoMdArrowDropright size={32} />
					</div>
				</div>
			</div>
		</div>
	);
}
